import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultComponent } from './default.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule, Routes } from '@angular/router';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTableModule } from '@angular/material/table';
import { DashboardComponent } from 'src/app/modules/dashboard/dashboard.component';
import { DeviceComponent } from 'src/app/modules/device/device.component';
import { RedliningComponent } from 'src/app/modules/redlining/redlining.component';
import { RegionComponent } from 'src/app/modules/region/region.component';
import { UserComponent } from 'src/app/modules/user/user.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatListModule } from '@angular/material/list';
import { QRCodeModule } from 'angularx-qrcode';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { LoginComponent } from 'src/app/modules/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { SettingComponent } from 'src/app/modules/setting/setting.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule } from '@angular/platform-browser'
import { CreateUserDialogComponent } from 'src/app/modules/configuration/createuser/createuser.component';
import { UserprofileComponent } from 'src/app/modules/user/userprofile/userprofile.component';
import { PermissionComponent } from 'src/app/modules/permission/permission.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { BuildingColorsComponent } from 'src/app/modules/configuration/buildingcolors/buildingcolors.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { ResetpasswordComponent } from 'src/app/modules/user/resetpassword/resetpassword.component';
import { HelpComponent } from 'src/app/modules/help/help.component';
import { MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatTooltipModule} from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import { LogComponent } from 'src/app/modules/log/log.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { UploadComponent } from 'src/app/modules/setting/upload/upload.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { RedliningPresetsComponent } from 'src/app/modules/configuration/redliningpresets/redliningpresets.component';

import { MatNativeDateModule } from '@angular/material/core';
import { MapsettingsComponent } from 'src/app/modules/setting/mapsettings/mapsettings.component';
import { EmailsettingsComponent } from 'src/app/modules/setting/emailsettings/emailsettings.component';
import { LanguageComponent } from 'src/app/modules/setting/language/language.component';
import { LogoutComponent } from 'src/app/modules/login/logout/logout.component';
import { ConfigurationComponent } from 'src/app/modules/configuration/configuration.component';
import { UnregisterinfoComponent } from 'src/app/modules/device/unregisterinfo/unregisterinfo.component';
import { MatMenuModule } from '@angular/material/menu';
import { DbprecacheComponent } from 'src/app/modules/configuration/dbprecache/dbprecache.component';
import { CachingSettingsComponent } from 'src/app/modules/region/cachingsettings/cachingsettings.component';
import { RackCacheComponent } from 'src/app/modules/configuration/rackcache/rackcache.component';
import { DatavalidityComponent } from 'src/app/modules/datavalidity/datavalidity.component';
import { AttachmentComponent } from 'src/app/modules/redlining/attachment/attachment.component';
import { SchemainfoComponent } from 'src/app/modules/configuration/schemainfo/schemainfo.component';
import { AdvancedcacheComponent } from 'src/app/modules/configuration/advancedcache/advancedcache.component';

@NgModule({
  declarations: [
    DefaultComponent,
    DashboardComponent,
    RegionComponent,
    DeviceComponent,
    UserComponent,
    RedliningComponent,
    LoginComponent,
    CreateUserDialogComponent,
    UserprofileComponent,
    SettingComponent,
    PermissionComponent,
    BuildingColorsComponent,
    ResetpasswordComponent,
    HelpComponent,
    LogComponent,
    UploadComponent,
    RedliningPresetsComponent,
    MapsettingsComponent,
    EmailsettingsComponent,
    LanguageComponent,
    LogoutComponent,
    ConfigurationComponent,
    UnregisterinfoComponent,
    DbprecacheComponent,
    CachingSettingsComponent,
    RackCacheComponent,
    DatavalidityComponent,
    AttachmentComponent,
    SchemainfoComponent,
    AdvancedcacheComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    SharedModule,
    RouterModule,
    MatSidenavModule,
    MatDividerModule,
    MatCardModule,
    FlexLayoutModule,
    MatDatepickerModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSlideToggleModule,
    MatListModule,
    QRCodeModule,
    MatChipsModule,
    MatFormFieldModule,
    MatIconModule,
    ReactiveFormsModule,
    MatButtonModule,
    FormsModule,
    MatSelectModule,
    MatInputModule,
    MatExpansionModule,
    MatDialogModule,
    MatGridListModule,
    MatToolbarModule,
    MatCheckboxModule,
    MatSnackBarModule,
    MatTabsModule,
    ColorPickerModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatProgressBarModule,
    ClipboardModule,
    MatProgressBarModule,
    MatNativeDateModule,
    MatMenuModule,
    MatRadioModule
  ],
  providers: [],
})
export class DefaultModule {}
